module.exports = "/shifts/components/modals/viewTaskTemplateSidebar-3bf70f.html";